import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';

const HeaderLinks = ({ onAdd }) => {
  const [t] = useTranslation();

  return <IconButton onClick={onAdd} type='add' size='small' variant='text' color='primary' tooltip={t('Tooltips.Add')} />;
};

HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
